<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box flex flex-col justify-center items-center text-center">
        <svg class="my-5" width="90" height="90" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="24" fill="#FF0000" />

            <image href="assets/icons/delete.svg" x="12" y="12" height="25px" width="25px" />
        </svg>

        <h2 class="font-bold text-2xl text-error">{{ 'archive.delete_file' | transloco }}</h2>
        <p class="text-neutral-800 text-base mt-5">{{ 'archive.are_you_sure_delete_file' | transloco }}</p>
        <div class="flex gap-2 w-full justify-between mt-10">
            <div class="w-[45%] h-[50px]">
                <app-custom-button (click)="closeModal(true)" buttonText="{{ 'shared.yes' | transloco }}"
                    backgroundColor="bg-error" textColor="text-black" borderColor="border:bg-error"
                    hoverBackgroundColor="hover:bg-error-1200"></app-custom-button>
            </div>
            <div class="w-[45%] h-[50px]">
                <app-custom-button (click)="closeModal(false)" buttonText="{{ 'shared.no' | transloco }}"
                    backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
            </div>
        </div>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button (click)="closeModal(false)">Close</button>
    </form>
</dialog>